module.exports = __webpack_public_path__ + "2f71aba5aefd9d6964cb80f387884a2f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manual/Admin-System-Manual-v2.0.pdf
// module id = 97nc
// module chunks = 1